/*
 * @Author: ZHANGJIAN
 * @Date: 2021-11-05 10:51:30
 * @LastEditTime: 2021-12-27 18:31:36
 * @LastEditors: ZHANGJIAN
 * @Description:
 */
/**
 * https://vee-validate.logaretm.com/v3/advanced/cross-field-validation.html#targeting-other-fields
 * vue 2.x 表单验证插件
 */

//定义多语言
VeeValidate.locale = {
  zh_TW: {
    code: "zh_TW",
    messages: {
      alpha: "{_field_} 須以英文組成",
      alpha_dash: "{_field_} 須以英數、斜線及底線組成",
      alpha_num: "{_field_} 須以英數組成",
      alpha_spaces: "{_field_} 須以英文及空格組成",
      between: "{_field_} 須介於 {min} 至 {max}之間",
      confirmed: " {_field_} 不一致",
      digits: "{_field_} 須為 {length} 位數字",
      dimensions: "{_field_} 圖片尺寸不正確。須為 {width} x {height} 像素",
      email: "{_field_} 須為有效的電子郵箱",
      excluded: "{_field_} 的選項無效",
      ext: "{_field_} 須為有效的檔案",
      image: "{_field_} 須為圖片",
      oneOf: "{_field_} 的選項無效",
      integer: "{_field_} 須為整數",
      length: "{_field_} 的長度須為 {length}",
      max: "{_field_} 不能大於 {length} 個字元",
      max_value: "{_field_} 不得大於 {max}",
      mimes: "{_field_} 須為有效的檔案類型",
      min: "{_field_} 不能小於 {length} 個字元",
      min_value: "{_field_} 不得小於 {min}",
      numeric: "{_field_} 須為數字",
      regex: "{_field_} 的格式錯誤",
      // required: "{_field_} 為必填",
      required: "請輸入您的{_field_}",
      required_if: "{_field_} 為必填",
      size: "{_field_} 的檔案須小於 {size}KB",
      double: "{_field_}字段必須為有效的小數",
    },
  },
};

var { ValidationProvider, ValidationObserver, localize, locale, extend } =
  VeeValidate;
let { email, required } = VeeValidateRules;
localize("zh_TW", locale.zh_TW);
// extend("email", {
//   message: "请填写正確的郵箱地址,用於找回密碼",
//   validate: (value) =>
//     /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value),
// });

extend("required", required);

extend("email", email);

/**
 * @description:验证账号
 * @param {*}
 */
extend("Vaccount", {
  message: "請輸入正確的賬號信息",
  validate: (value) => /^([\S]){4,100}$/.test(value),
});
extend("regVaccount", {
  message: "請輸入正確的賬號信息",
  validate: (value) => /^([\S]){4,20}$/.test(value),
});
/**
 * @description: 验证密码
 * @param {*}
 */
extend("Vpwd", {
  message: "請輸入6-20位英文字母或數字",
  validate: (value) => /^[a-zA-Z0-9]{6,20}$/.test(value),
});
/**
 * @description:二次确认校验
 * @param {*}
 */
extend("VconfirmPwd", {
  params: ["target"],
  //target值需要在目标dom配置vid
  validate(value, { target }) {
    return value === target;
  },
  message: "兩次輸入的密碼不一致!",
});
